import Markdown from 'markdown-to-jsx';
import React from 'react';
import styles from '@dazn/lp-web/src/components/CompetitionDisplay/competition-display.module.css';

interface ICompetitionDisplayProps {
    data: any;
    key: number;
    disableAnimation: boolean;
}
export const CompetitionDisplay: React.FC<ICompetitionDisplayProps> = ({
    data
}) => {
    const {title = '', description = '', logos = []} = data;
    return (
        <div
            data-target="competition-display-wrapper"
            className={styles.competitionDisplayWrapper}
        >
            {title && (
                <Markdown
                    className={styles.competitionDisplayTitle}
                    data-target="competition-display-title"
                    options={{
                        forceBlock: true
                    }}
                >
                    {title}
                </Markdown>
            )}
            {description && (
                <Markdown
                    className={styles.competitionDisplayDescription}
                    data-target="competition-display-description"
                    options={{
                        forceBlock: true
                    }}
                >
                    {description}
                </Markdown>
            )}
            {
                <div
                    data-target="competition-display-logos-wrapper"
                    className={styles.competitionDisplayLogosWrapper}
                >
                    {logos?.map(({title = '', logo = ''}) => {
                        return (
                            <div
                                className={styles.competitionDisplayLogoWrapper}
                                data-target="competition-display-logo-card"
                            >
                                <div className={styles.competitionDisplayLogo}>
                                    {logo && <img src={logo} />}
                                </div>
                                {title && (
                                    <span className={styles.logoTitle}>
                                        {title}
                                    </span>
                                )}
                            </div>
                        );
                    })}
                </div>
            }
        </div>
    );
};
